import {
    isPlayerAction,
    Projection,
    SharedGameState,
    useGameStore,
} from '@glark-newco/game-library';
import {shallow} from 'zustand/shallow';
import {isAssignLinkPayload, isDisplayPlayScenePayload} from '../SupplyChainPayloadTypes';

export interface SpareRopeSlice extends SharedGameState {
    spareRopeWasUsed?: boolean;
    displayPlaySceneSeen?: boolean;
}

export const spareRopeProjection: Projection<SpareRopeSlice> = {
    name: 'spareRopeProjection',
    project: (state, newEvents) => {
        const result: Partial<SpareRopeSlice> = {};
        let displaySeen = state.displayPlaySceneSeen ?? false;
        let ropeUsed = state.spareRopeWasUsed ?? false;

        newEvents.forEach(ev => {
            if (isPlayerAction(ev) && isDisplayPlayScenePayload(ev.payload)) {
                displaySeen = true;
            } else if (displaySeen && isPlayerAction(ev) && isAssignLinkPayload(ev.payload)) {
                ropeUsed = true;
            }
        });

        if (displaySeen !== state.displayPlaySceneSeen) {
            result.displayPlaySceneSeen = displaySeen;
        }
        if (ropeUsed !== state.spareRopeWasUsed) {
            result.spareRopeWasUsed = ropeUsed;
        }

        return result;
    },
    reset: () => ({
        spareRopeWasUsed: false,
        displayPlaySceneSeen: false,
    }),
};

export const useWasSpareRopeUsed = (): boolean => {
    return useGameStore(
        (s: SpareRopeSlice) => s.spareRopeWasUsed ?? false,
        shallow,
    );
};
